import { useEffect, useRef } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { ToastId, ToastSeverity, useToast } from 'framework/ui/Toast';
import { dismissMessage } from './messageActions';
import { MessageState } from './messageTypes';
import getMessageContent from './getMessageContent';

const MessageToasts = () => {
  const dispatch = useDispatch();
  const messages = useSelector((state: { message: MessageState[] }) => state.message, shallowEqual);
  const { pathname } = useLocation();
  const toast = useToast();
  const toastIdsRef = useRef(new Map<MessageState, ToastId>());

  useEffect(() => {
    const toastIds = toastIdsRef.current;
    const pageMessages = messages.filter(messageState => messageState.message && messageState.pathname === pathname);

    toastIds.forEach((toastId, messageState) => {
      if (!pageMessages.includes(messageState)) {
        toast.close(toastId);
        toastIds.delete(messageState);
      }
    });

    pageMessages.forEach(messageState => {
      const { message, pathname: messagePathname, messageContext } = messageState;

      if (!message || toastIds.has(messageState)) return;

      toastIds.set(
        messageState,
        toast.show({
          message: getMessageContent(message.content),
          severity: message.status as ToastSeverity,
          onClose: () => dispatch(dismissMessage(message, messagePathname, messageContext)),
        }),
      );
    });
  }, [messages, pathname, toast, dispatch]);

  return null;
};

export default MessageToasts;
